import * as THREE from 'three';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader';
import { GLTF, GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

export function positionCameraOnRobot(robot: THREE.Mesh, camera: THREE.Camera) {
  let offsetVector = new THREE.Vector3(-1.5, 0, 2);
  const target = robot.position || new THREE.Vector3(0, 0, 0);
  const heading = robot.rotation.z || 0;
  //offsetVector.applyEuler(new THREE.Euler(0, 0, heading, 'ZXY'));
  camera.position.copy(target).add(offsetVector);
  camera.lookAt(target);
  camera.rotation.z = -Math.PI / 2;
}


export interface TextureWithSize {
  width: number;
  height: number;
  texture: THREE.Texture;
}

export interface GLTFResult {
  scene: THREE.Object3D;
  animations: THREE.AnimationClip[];
}

export function loadTextureFromBase64(base64String: string): Promise<TextureWithSize> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const texture = new THREE.Texture(img);
      texture.needsUpdate = true;
      resolve({
        width: img.width,
        height: img.height,
        texture
      });
    };
    img.onerror = (error) => {
      reject(error);
    };
    img.src = `data:image/png;base64,${base64String}`;
  });
}

export function loadTextureFromUrl(url: string): Promise<TextureWithSize> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const texture = new THREE.Texture(img);
      texture.needsUpdate = true;
      resolve({
        width: img.width,
        height: img.height,
        texture
      });
    };
    img.onerror = (error) => {
      reject(error);
    };
    img.src = url;
  });
}

export function loadTextureFromBuffer(buffer: ArrayBuffer): Promise<TextureWithSize> {
  return new Promise((resolve, reject) => {
    const blob = new Blob([buffer]);
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      const texture = new THREE.Texture(img);
      texture.needsUpdate = true;
      URL.revokeObjectURL(url);
      resolve({
        width: img.width,
        height: img.height,
        texture
      });
    };
    img.onerror = (error) => {
      reject(error);
    };
    img.src = url;
  });
}

export async function loadFont(fontUrl: string) {
  const loader = new FontLoader();
  return new Promise<any>((resolve, reject) => {
    loader.load(fontUrl, resolve, undefined, reject);
  });
}

export async function loadTextGeometry(text: string) {
  const loader = new FontLoader();
  const font = await new Promise<any>((resolve, reject) => {
    loader.load('https://threejs.org/examples/fonts/helvetiker_regular.typeface.json', resolve, undefined, reject);
  });
  const geometry = new TextGeometry(text, {
    font: font,
    size: 0.2,
    depth: 0.02,
    curveSegments: 12,
    bevelEnabled: false
  });
  return geometry;
}

export function loadGlTFModel(path: string): Promise<GLTF> {
  const loader = new GLTFLoader();
  return new Promise((resolve, reject) => {
    loader.load(
      path,
      (gltf) => resolve(gltf),
      undefined, // Optional: Progress callback
      (error) => reject(error)
    );
  });
}

export async function loadModel(loader: GLTFLoader, path: string): Promise<GLTFResult> {
  return new Promise((resolve, reject) => {
    loader.load(
      path,
      (gltf: GLTF) => resolve({ scene: gltf.scene, animations: gltf.animations }),
      undefined, // Optional: Progress callback
      (error) => reject(error)
    );
  });
}

